/* eslint-disable import/prefer-default-export */

/**
 * 引数で受け取ったURLを新しいタブで開く
 * @param url 開くURL
 */
const openUrl = (url: string): void => {
  window.open(url);
};

/**
 * ヘルプページを開く
 */
export const openHelpPage = (): void => {
  openUrl('https://www.sourcenext.com/r/p/sim/menu1');
};

/**
 * ご注意ページを開く
 */
export const openAttentionPage = (): void => {
  openUrl('https://www.sourcenext.com/r/p/sim/menu2');
};
